export default {
  display: {
    class: [
      // Display
      'inline',

      // Spacing
      'p-3',

      // Shape
      'rounded-md',

      // Colors
      'text-surface-700',

      // States
      'hover:bg-surface-100 hover:text-surface-700',

      // Transitions
      'transition',
      'duration-200',

      // Misc
      'cursor-pointer',
    ],
  },
};
